/**
 * index.js — Application Entry Point
 *
 * This is the first file React loads.
 * It mounts the <App> component into the <div id="root"> in public/index.html
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Mount the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
